/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TunnelSectionDto } from '../../models/tunnel-section-dto';

export interface CreateTunnelSection$Params {
      body: TunnelSectionDto
}

export function createTunnelSection(http: HttpClient, rootUrl: string, params: CreateTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelSectionDto>> {
  const rb = new RequestBuilder(rootUrl, createTunnelSection.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TunnelSectionDto>;
    })
  );
}

createTunnelSection.PATH = '/v1/tunnelsections';
